const HTMLEntities = (el) => {
  el.innerHTML = el.textContent;
};

export default HTMLEntities;
